import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import {
  CreateProductionCodeResponse,
  DownloadProductionCodeRequestFilePayload,
  ProductionCodeRequest,
  ProductionCodeRequestApprovalPayload,
  ProductionCodeRequestDetails,
  ProductionCodeRequestFormData,
  ProductionCodeRequestFormPayload,
  ProductionCodeRequestListPayload,
  ProdukcioniKodIzvodPayload,
  ProdukcioniKodIzvodResponse,
} from "./productionCode.types";

class ProductionCodeRepo {
  getAllProductionCodeRequest = (
    payload: ProductionCodeRequestListPayload
  ): Promise<ApiResponseObject<ProductionCodeRequest[]>> => {
    return axios.post("/sviZahteviProdukcionihKodova", payload);
  };

  createProductionCodeRequest = (
    payload: ProductionCodeRequestFormPayload
  ): Promise<ApiResponseObject<CreateProductionCodeResponse | null>> => {
    return axios.post("/zahtevProdukcionihKodovi", payload);
  };

  downloadRequestProductionCodes = (
    payload: DownloadProductionCodeRequestFilePayload
  ): Promise<ApiResponseObject<string>> => {
    return axios.post("/skiniKodoveZahteva", { zahtevId: payload.zahtevId });
  };

  downloadRequestProformaInvoice = (
    payload: DownloadProductionCodeRequestFilePayload
  ): Promise<ApiResponseObject<{ content: string }>> => {
    return axios.post("/skiniPredracunZahtevaZaProdukcioniKod", {
      zahtevId: payload.zahtevId,
    });
  };

  getProductionCodeRequestFormData = (
    id: number | null
  ): Promise<ApiResponseObject<ProductionCodeRequestFormData>> => {
    return axios.get("/inicijalniPodaciZaZahtev", {
      params: { obveznikTipId: id },
    });
  };

  getProductionCodeRequestDetails = (
    id: number | null
  ): Promise<ApiResponseObject<ProductionCodeRequestDetails>> => {
    return axios.get("/pregledZahtevaProdukcionogKoda", {
      params: { zahtevId: id },
    });
  };

  acceptProductionCodeRequest = (
    payload: ProductionCodeRequestApprovalPayload
  ): Promise<ApiResponseObject<void>> => {
    return axios.post("/prihvatiZahtevZaProdukcioniKod", payload);
  };

  declineProductionCodeRequest = (
    payload: ProductionCodeRequestApprovalPayload
  ): Promise<ApiResponseObject<void>> => {
    return axios.post("/odbijZahtevZaProdukcioniKod", payload);
  };

  getAllProdukcioniKodoviListaIzvoda = (
    payload: ProdukcioniKodIzvodPayload
  ): Promise<ApiResponseObject<ProdukcioniKodIzvodResponse>> => {
    return axios.post("/mfin/produkcioniKodoviIzvodi", payload);
  };
}

export const productionCodeRepo = new ProductionCodeRepo();
